<template>
    <div>
         <validation-observer ref="userFormCustomer">
            <b-form class="formBox" inline  > 
                <validation-provider :name="$t('dealer.wizzard.userName')" :rules="{ required: true, min: 3 }" v-slot="validationContext">
                        <b-form-group class="inputGrp" :label="$t('dealer.wizzard.userName')" label-for="userName">
                            <b-form-input
                                id="userName"
                                v-model="name"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                </validation-provider>
                <validation-provider :name="$t('dealer.wizzard.userTask')" :rules="{ required: false, min: 3 }" v-slot="validationContext">
                    <b-form-group class="inputGrp" :label="$t('customer.wizzard.userTask')" label-for="task">
                            <b-form-input
                                id="task"
                                v-model="task"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-input>
                        </b-form-group>
                </validation-provider>
                <validation-provider :name="$t('dealer.wizzard.email')" :rules="{ required: false, email: true}" v-slot="validationContext">
                        <b-form-group class="inputGrp"  :label="$t('dealer.wizzard.email')" label-for="email">
                            <b-form-input
                                id="email"
                                v-model="email"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                </validation-provider>
                <validation-provider :name="$t('dealer.wizzard.phoneNo')" :rules="{ required: false, regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ }" v-slot="validationContext">
                        <b-form-group class="inputGrp" :label="$t('dealer.wizzard.phoneNo')" label-for="phone">
                            <MaskedInput
                            id="phone"
                            v-model="phone_no"
                            mask="\+\ 11 (111) 111 1111"
                            :placeholder="$t('dealer.wizzard.phoneNo')"
                            type="tel" 
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"/>
                            
                            <b-form-invalid-feedback style="display: block" id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                </validation-provider>
               
                <div class="submitButton">
                    <b-button size="lg" variant="primary" :title="$t('general.add')" @click="addUser"> <b-icon icon="plus" />{{ $t('general.add')}}</b-button>
                </div>
            </b-form>
        </validation-observer>
        <b-table-simple hover responsive>
            <b-thead>
                <b-th> {{$t('customer.users.name')}}</b-th>
                <b-th> {{$t('customer.users.task')}} </b-th>
                <b-th> {{$t('customer.users.phone')}} </b-th>
                <b-th> {{$t('customer.users.mail')}} </b-th>
                <b-th> {{$t('general.operation')}} </b-th>
            </b-thead>
            <b-tbody>
               <b-tr v-for="(user, index) in userForm " :key="index">
                    <b-td> {{user.name}} </b-td>
                    <b-td> {{user.task}} </b-td>
                    <b-td> {{user.phone_no}} </b-td>
                    <b-td> {{user.email}} </b-td>
                    <b-td> 
                        <b-button size="sm" title="Sil" variant="danger" @click="deleteUser(index)"> <b-icon icon="trash" aria-hidden="true"></b-icon> </b-button>
                    </b-td>
               </b-tr>
            </b-tbody>
        </b-table-simple>
    </div>
        

</template>
               
<script>
    import MaskedInput from 'vue-masked-input'

    export default {
        name: "UserForm",
        data: function(){
            return{
                name: null,
                task: null,
                email: null,
                phone_no: "+90",
                userForm: Object.keys(this.data).length > 0 ? this.data.contact : [],
             
            }
        },
        props:{
            data: Object,
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
            addUser() {
                this.$refs.userFormCustomer.validate().then(success => {
                    if(success){
                        if(this.userForm == undefined)
                            this.userForm = []
                        this.userForm.push(
                            {
                                name: this.name,
                                task: this.task,
                                email: this.email,
                                phone_no: this.phone_no.replaceAll(" ","").replace("(","").replace(")",""),
                            }
                        )
                        return true;
                    } else{
                        return false;
                    }
                })
               
            },
            deleteUser(index){
                this.userForm.splice(index, 1);
            }
        },
        components:{
            MaskedInput
        }
    }
</script>

<style lang="css" scoped> 
    @import "../styles/userForm.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/components/UserForm.vue